import type { PropsWithChildren } from 'react'
import { cn } from '@/lib/utils'

interface PanelHeaderProps extends PropsWithChildren {
  className?: string
}

export function PanelHeader({ children, className }: PanelHeaderProps) {
  return (
    <div
      className={cn('w-full px-6 py-2 bg-[var(--brand-blue-4)]/20', className)}
    >
      {children}
    </div>
  )
}
